import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { startEditProject } from '../../../store/actions/projects';

const styles = theme => ({
  root: {
    width: '130px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: theme.spacing.unit,
  },
});



//States: undefined, started, hold, closed
class JobStatus extends Component {
  constructor(props){
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  buttonName = () => {
    const { project } = this.props;

    switch (project.status) {
      case "active":
        return "close";
      case "hold":
        return "start";
      case "closed":
        return "start";
      default:
        return "start";
    }
  }

  statusName = () => {
    const { project } = this.props;

    switch (project.status) {
      case "active":
        return "Active";
      case "held":
        return "Held";
      case "closed":
        return "Closed";
      default:
        return "New";
    }
  }

  render() {
    const { classes, project, startEditProject } = this.props;
    const { anchorEl } = this.state;

    return (
      <div className={classes.root}>
        <Typography>{this.statusName(project.currentStatus)}</Typography>
        {false && project.status !== "active" &&
          <Button
            color="primary"
            onClick={() => startEditProject(project.id, { status: "active" })}
          >
            {this.buttonName()}
          </Button>
        }
        {project.status !== "active" &&
          <div>
            <Button
              color="primary"
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              Action
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem
                onClick={() => {
                  startEditProject(project.id, { status: "active" });
                  this.handleClose();
                }}
              >
                Active
              </MenuItem>
            </Menu>
          </div>
        }
        {project.status === "active" &&
          <div>
            <Button
              color="primary"
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              Action
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem
                onClick={() => {
                  startEditProject(project.id, { status: "closed" });
                  this.handleClose();
                }}
              >
                Close
              </MenuItem>
              <MenuItem
                onClick={() => {
                  startEditProject(project.id, { status: "held" });
                  this.handleClose();
                }}
              >
                Hold
              </MenuItem>
            </Menu>
          </div>
        }
      </div>
    );
  }
}

const mapDispatchToProps = {
  startEditProject,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(JobStatus);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/JobStatus.jsx